/**
 * Normalizes protocol XML text for display: the XML is indented, so every line is trimmed, blank
 * lines at the start and the end are dropped, and the line breaks in between are kept (the panel
 * renders them with `white-space: pre-line`). Plain text only.
 */
export function normalizeText(raw) {
    if (typeof raw !== 'string') return '';

    const lines = raw
        .replace(/\r\n?/g, '\n')
        .split('\n')
        .map((line) => line.trim());
    let start = 0;
    let end = lines.length;
    while (start < end && !lines[start]) start += 1;
    while (end > start && !lines[end - 1]) end -= 1;

    return lines.slice(start, end).join('\n');
}
